const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/IdentityProofCard/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        identityProofTitle: 'Identitätsnachweis',
        identityProofText:
            'Für einen vollständigen App-Zugang weisen Sie sich bitte mit einem gültigen Ausweis bei uns aus.',
    },
    __RELATIVE_SOURCE_FILE__
);
